import { render, staticRenderFns } from "./partidaDocs.vue?vue&type=template&id=cb4c8efc&"
import script from "./partidaDocs.vue?vue&type=script&lang=js&"
export * from "./partidaDocs.vue?vue&type=script&lang=js&"
import style0 from "./partidaDocs.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports